import React, { useEffect, useState } from 'react'
import { type FieldValues, type UseFormRegister } from 'react-hook-form'

import styles from './styles.module.scss'

type InputType = {
  register?: UseFormRegister<FieldValues>
  isDropdown?: boolean
  multiline?: boolean
  onChange?: (value: string) => void
  defaultValue?: string
  dropdownItems?: string[]
  name: string
  required?: boolean
  rest?:
    | React.InputHTMLAttributes<HTMLInputElement>
    | React.TextareaHTMLAttributes<HTMLTextAreaElement>
  pattern?: {
    value: RegExp
    message: string
  }
}

const CustomInput = ({
  register,
  name,
  rest,
  pattern,
  required = true,
  isDropdown = false,
  multiline = false,
  dropdownItems = [],
  defaultValue,
  onChange,
}: InputType) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  useEffect(() => {
    if (defaultValue) {
      onChange?.(defaultValue)
    }
  }, [])

  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      {multiline ? (
        <textarea
          {...register?.(name, {
            required,
            pattern,
          })}
          {...(rest as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
          className={`${styles.input} ${styles.textarea} ${rest?.className || ''}`}
        />
      ) : (
        <input
          {...register?.(name, {
            required,
            pattern,
          })}
          {...(rest as React.InputHTMLAttributes<HTMLInputElement>)}
          readOnly={isDropdown && !!dropdownItems}
          style={{
            cursor: isDropdown && !!dropdownItems ? 'pointer' : 'inherit',
            textOverflow: isDropdown && !!dropdownItems ? 'ellipsis' : 'inherit',
            overflow: isDropdown && !!dropdownItems ? 'hidden' : 'inherit',
            ...rest?.style,
          }}
          onClick={() => {
            if (isDropdown && dropdownItems) setIsDropdownOpen((prev) => !prev)
          }}
          onBlur={() => {
            if (isDropdown && dropdownItems) setTimeout(() => setIsDropdownOpen(false), 500)
          }}
          className={`${styles.input} ${rest?.className || ''}`}
        />
      )}
      {isDropdown && dropdownItems && (
        <div
          className={styles.dropdown}
          style={{
            transition: 'all 0.3s',
            overflow: 'hidden',
            opacity: isDropdownOpen ? 1 : 0,
            height: isDropdownOpen ? 'auto' : 0,
          }}
        >
          {dropdownItems?.map((item, i) => {
            return (
              <span
                key={item + i}
                onClick={() => {
                  onChange?.(item)
                  setIsDropdownOpen(false)
                }}
              >
                {item}
              </span>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default CustomInput
